import { render } from "./PartRequests.vue?vue&type=template&id=6bef8bff"
import script from "./PartRequests.vue?vue&type=script&lang=js"
export * from "./PartRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__